var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsAutomationsEventsCustomField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 31,
    fill: "#E7FFE6",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#34D900",
    className: "background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 16.006c-.552 0-1 .448-1 1v6c0 .552-.448 1-1 1H9c-.552 0-1-.448-1-1v-14c0-.552.448-1 1-1h6c.552 0 1-.448 1-1s-.448-1-1-1H9c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-6c0-.552-.448-1-1-1zm-15 .76v4.24c0 .552.448 1 1 1h4.24c.266.001.521-.103.71-.29l6.92-6.93 2.84-2.78c.19-.188.296-.444.296-.71 0-.267-.107-.522-.296-.71l-4.24-4.29c-.188-.19-.443-.296-.71-.296-.267 0-.522.106-.71.296l-2.82 2.83-6.94 6.93c-.187.189-.292.444-.29.71zm10.76-8.35l2.83 2.83-1.42 1.42-2.83-2.83 1.42-1.42zM12 17.176l5.93-5.93 2.83 2.83-5.93 5.93H12v-2.83z",
    transform: "translate(14 14)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsAutomationsEventsCustomField);
export default __webpack_public_path__ + "static/media/illustrations-automations-events-custom-field.7fb7a471.svg";
export { ForwardRef as ReactComponent };